import { Component, OnInit } from '@angular/core';
import {ListTemplate} from "../../../../../shared/models/list-template";
import {PermissionConst} from "../../../../../core/models/permission-const.model";
import {RegistersService} from "../../../../../core/services/registers.service";
import {SessionManagerService} from "../../../../../core/services/session-manager.service";
import {Title} from "@angular/platform-browser";
import {HttpErrorResponse} from "@angular/common/http";
import {currencyStringFormatter, percentageStringFormatter} from "../../../../../core/utils/string-formatters";

@Component({
  selector: 'app-exams-register-list',
  templateUrl: './exams-register-list.component.html',
  styleUrls: ['./exams-register-list.component.scss']
})
export class ExamsRegisterListComponent implements OnInit {

  searchString: string = "";
  orderingItem: string = "description";

  listTemplate: ListTemplate = {
    loading: true,
    showSearch: true,
    searchBarPlaceholder: "Buscar por Exame",
    showAdvancedSearch: false,
    newDataText: "+ Novo Exame",
    newDataRouterLink: this.canNewData ? "register" : undefined,
    notFoundMessage: "Nenhum exame encontrado",
    header: [
      { name: "description", label: "Descrição", widthInPercentage: "50%", width: '430px' },
      { name: "value", displayStringConvertionFunction: currencyStringFormatter, label: "Custo", widthInPercentage: "25%", width: '220px' },
      { name: "aliquot", displayStringConvertionFunction: percentageStringFormatter, label: "Alíquota", widthInPercentage: "25%", width: '220px' }
    ],
    onHeaderItemClick: (value: string) => {
      let invertString = '';
      if (this.orderingItem == value) {
        this.listTemplate.invertedOrdering = !this.listTemplate.invertedOrdering;
        if (this.listTemplate.invertedOrdering)
          invertString = '-';
      }
      this.fetchList(this.searchString, `${invertString}${value}`, this.listTemplate.is_active);
      this.orderingItem = value;
      this.listTemplate.selectedOrdering = value;
    },
    onSearchFocusOut: (value: string) => {
      this.searchString = value;
      this.fetchList(value, this.orderingItem, this.listTemplate.is_active);
    },
    onClickActive: () => {
      this.listTemplate.is_active = !this.listTemplate.is_active;
      this.fetchList(this.searchString, this.orderingItem, this.listTemplate.is_active);
    },
    selectedOrdering: this.orderingItem,
    invertedOrdering: false,
    exportUrl: this.canExport ? '/exam_templates/export' : undefined,
    exportOptions: {
      id: 'ID',
      description: 'Descrição',
      created_at: 'Criado em'
    }
  };

  constructor(private registersService: RegistersService, private sessionManager: SessionManagerService,
              private titleService: Title) {
    this.titleService.setTitle('ELEVE - Exames Externos');
  }

  ngOnInit(): void {
    this.initializeList();
  }

  get canNewData() {
    const permissions = [PermissionConst.add_exam, PermissionConst.change_exam, PermissionConst.view_exam];
    return permissions.every((p) => this.sessionManager.getUserPermission(p));
  }

  get canExport() {
    const permissions = [PermissionConst.export_exam, PermissionConst.change_exam, PermissionConst.view_exam];
    return permissions.every((p) => this.sessionManager.getUserPermission(p));
  }

  initializeList() {
    this.fetchList("", "description", this.listTemplate.is_active);
  }

  fetchList(searchString: string, orderingItem: string, isActive: boolean | undefined) {
    this.listTemplate.loading = true;
    this.listTemplate.data = undefined;

    this.registersService.externalExamsList(searchString, orderingItem, isActive).subscribe(response => {
      this.listTemplate.loading = false;
      this.listTemplate.data = response;
      this.listTemplate.hasNext = response.next != null;
    }, error => {
      const response = error as HttpErrorResponse;
      this.listTemplate.loading = false;
      this.listTemplate.error = true;
      this.listTemplate.errorMessage = response.error['detail'];
    });
  }

  loadMore(page: number) {
    this.listTemplate.loadingNext = true;
    this.registersService.externalExamsList(this.searchString, this.orderingItem, this.listTemplate.is_active, page).subscribe(
      response => {
        this.listTemplate.hasNext = response.next != null;
        response.results!.map(item => this.listTemplate.data!.results!.push(item));
        this.listTemplate.loadingNext = false;
      },
      error => {
        const response = error as HttpErrorResponse;
        this.listTemplate.loading = false;
        this.listTemplate.error = true;
        this.listTemplate.errorMessage = response.error['detail'];
      });
  }
}
